export default {
  TOKEN_KEY: "token",
  REFRESH_TOKEN_KEY: "refreshToken",
  REFRESH_TOKEN_ID_KEY: "refreshTokenId",
  STRINGIFIED_USER_DATA_KEY: "user",
  SELECTED_ACADEMIC_YEAR_KEY: "selectedAcademicYearId",
  JWT_VERSION_KEY: "version",
  SELECTED_CHILD_KEY: "childId",
  ORIGINAL_USER_KEY: "originalUser",
  PAYMOB_URL: "paymobUrl"
};